import React, { useEffect } from "react"
import clsx from "clsx"

import { LazyImage } from "components"
import { getComboItemFoodDetail } from "utils"
import BuyXFreeXModalCardButtons from "./BuyXFreeXModalCardButtons"
import classes from "./BuyXFreeXModalCard.module.scss"

const BuyXFreeXModalCard = props => {
  const {
    editMode,
    isFixed,
    maxQty,
    comboSetItem,
    comboSetId,
    selectedComboItems,
    setSelectedComboItems
  } = props

  const isMaxQtyReached = () => {
    if (isFixed) return false

    const thisComboSetSelectedComboItems =
      selectedComboItems.filter(selectedComboItem =>
        selectedComboItem.comboSetId === comboSetId
      )

    const totalSelectedComboItems =
      thisComboSetSelectedComboItems.reduce((t, selectedComboItem) =>
        t += selectedComboItem.quantity
        , 0
      )

    return totalSelectedComboItems === maxQty
  }

  const autoSelectComboItemIfIsFixed = () => {
    if (!isFixed) return
    if (editMode) return

    if (comboItemFoodDetail === null) return

    setSelectedComboItems(prev =>
      [...prev, comboItemFoodDetail]
    )
  }

  useEffect(() => {
    autoSelectComboItemIfIsFixed()
  }, [])

  const comboItemFoodDetail =
    getComboItemFoodDetail(
      comboSetItem,
      comboSetId
    )

  if (comboItemFoodDetail === null) return null

  const outOfStock =
    comboItemFoodDetail.isAvailable
      ?
      comboItemFoodDetail.outOfStock ||
      (
        comboItemFoodDetail.stockManagement &&
        comboItemFoodDetail.availableQuantity <= 0
      )
      :
      true

  const selectedComboItem =
    selectedComboItems.find(item =>
      item.optionId === comboSetItem.optionId
    )

  const isSelected = !!selectedComboItem

  const reachedMaxQty = isMaxQtyReached()

  const disableRestOfItems =
    reachedMaxQty &&
    !selectedComboItem?.quantity

  const disabled =
    outOfStock || disableRestOfItems

  return (
    <div className={classes["container"]}>
      <div
        className={clsx(
          classes["wrapper"],
          disabled && classes["disabled"],
          isSelected && classes["isActive"]
        )}
      >
        <LazyImage
          src={comboItemFoodDetail.foodImageCover}
          imageWidth={100}
          quality={80}
          className={classes["image"]}
        />
        <div className={classes["details"]}>
          <div className={classes["code"]}>
            کد: {comboItemFoodDetail.foodCode}
          </div>
          <div className={classes["name"]}>
            {comboItemFoodDetail.foodName}
          </div>
          <div className={classes["optionName"]}>
            {!comboItemFoodDetail.isSimple ?
              (comboItemFoodDetail.optionName) : ""
            }
          </div>
        </div>
        {outOfStock
          ?
          <div className={classes["outOfStock"]} >
            ناموجود
          </div>
          :
          <div className={classes["right"]}>
            {isFixed
              ?
              <div className={classes["quantity"]}>
                {comboItemFoodDetail.quantity}x
              </div>
              :
              <BuyXFreeXModalCardButtons
                disabled={disabled}
                reachedMaxQty={reachedMaxQty}
                comboItemFoodDetail={comboItemFoodDetail}
                quantity={selectedComboItem?.quantity}
                setSelectedComboItems={setSelectedComboItems}
              />
            }
          </div>
        }
      </div>
    </div>
  )
}

export default BuyXFreeXModalCard